import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Components
import { Format, SquareIcon, Text } from '../../../../..'

// Selectors
import { selectMinSellingPrice } from '../../../../../../store/selectors/shouldYouSell'

// Styles
import baseStyles from '../../ShouldYouSell.module.scss'

const Label = () => {
  const minSellingPrice = useSelector(selectMinSellingPrice)

  return (
    <>
      <SquareIcon className={baseStyles.icon} backgroundColor='warning' icon='money' />
      <div className={baseStyles.label}>
        <Text size='s' variant='warning' weight='semibold'>
          <FormattedMessage id='ShouldYouSell.cashPosition.bad.label' defaultMessage='Could owe money' />
        </Text>
        <Text variant='neutralCool' variantCount='600' size='xs'>
          <FormattedMessage
            id='ShouldYouSell.cashPosition.bad.subLabel'
            defaultMessage='You’d need to sell for at least {minSellingPrice}'
            values={{
              minSellingPrice: (
                <Text element='span' weight='semibold' variant='neutralCool' variantCount='600'>
                  <Format.Currency value={minSellingPrice} abbreviate />
                </Text>
              )
            }}
          />
        </Text>
      </div>
    </>
  )
}

export default Label
